/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import { useQuery } from '@tanstack/react-query';

import Message from './Message';

// import mailUser01 from '../../../../../../assets/images/user-40-11.jpg';
// import mailUser02 from '../../../../../../assets/images/user-avatar-80.png';
// import mailImage from '../../../../../../assets/images/inbox-image.jpg';
import { useUiStore } from '../../../../../../store';
import TicketService from '../../../../../../services/TicketService';

export default function Messages({
  inboxSidebarOpen,
  setInboxSidebarOpen,
  currentTicketId,
  currentCall,
}) {
  const loanHeaderHeight = useUiStore((state) => state.loanHeaderHeight);

  const { data: ticket } = useQuery({
    queryKey: ['ticket', currentTicketId],
    queryFn: () => TicketService.getTicket(currentTicketId),
    enabled: !!currentTicketId,
  });

  const { data: ticketConversations } = useQuery({
    queryKey: ['ticketConversations', currentTicketId],
    queryFn: () => TicketService.getTicketConversations(currentTicketId),
    enabled: !!currentTicketId,
  });

  const subject = currentCall ? (
    <span className="capitalize">
      {currentCall.call_data.direction} Phone Call
    </span>
  ) : (
    ticket?.subject
  );
  const callParticipant = currentCall
    ? currentCall.call_data.participants.find(
        (prtcpnt) => prtcpnt.participant_type !== 'Agent'
      )
    : null;

  return (
    <div
      style={{
        height: `calc(100vh - ${loanHeaderHeight}px - 64px - 32px - 32px)`,
      }}
      className={`md:overflow-y-auto !md:h-auto grow flex flex-col md:translate-x-0 transition-transform duration-300 ease-in-out ${
        inboxSidebarOpen ? 'translate-x-[110%]' : 'translate-x-0'
      }`}
    >
      {/* Header */}
      <div className="sticky top-16">
        <div className="flex items-center justify-between bg-slate-50 dark:bg-[#161F32] border-b border-slate-200 dark:border-slate-700 px-4 sm:px-6 md:px-5 h-16 md:hidden">
          {/* Buttons on the left side */}
          <div className="flex">
            {/* Close button */}
            <button
              type="button"
              className="md:hidden text-slate-400 hover:text-slate-500 mr-4"
              onClick={() => setInboxSidebarOpen(!inboxSidebarOpen)}
              aria-controls="inbox-sidebar"
              aria-expanded={inboxSidebarOpen}
            >
              <span className="sr-only">Close sidebar</span>
              <svg
                className="w-6 h-6 fill-current"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="grow px-4 sm:px-6 md:px-5 py-4 bg-white">
        {/* Mail subject */}
        <header className="sm:flex sm:items-start sm:justify-between mb-4">
          <h1 className="text-xl leading-snug text-slate-800 dark:text-slate-100 font-bold mb-1 sm:mb-0 ml-2">
            {subject}
          </h1>
          {/* <button
            type="button"
            className="text-xs inline-flex font-medium bg-sky-100 dark:bg-sky-500/30 text-sky-600 dark:text-sky-400 rounded-full text-center px-2.5 py-1 whitespace-nowrap"
          >
            Exciting news
          </button> */}
        </header>

        {/* Messages box */}
        {currentTicketId && (
          <div className="bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 px-6 divide-y divide-slate-200 dark:divide-slate-700">
            <Message
              conversation={{
                id: 1,
                from_email: ticket?.support_email,
                to_emails: [ticket?.requester?.email],
                body: ticket?.description,
                created_at: ticket?.created_at,
                body_text: ticket?.description_text,
              }}
            />
            {ticketConversations?.map?.((conversation) => {
              return (
                <Message
                  key={conversation.id}
                  conversation={conversation}
                  //  id={mail.id}
                  // open={mail.open}
                  // image={mail.image}
                  // name={mail.name}
                  //  email={mail.email}
                  //  date={mail.date}
                  //  recipients={mail.recipients}
                  //  excerpt={mail.excerpt}
                  //  message={mail.message}
                />
              );
            })}
          </div>
        )}
        {currentCall && (
          <div className="bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 px-6 divide-y divide-slate-200 dark:divide-slate-700">
            <Message
              conversation={{
                id: currentCall.call_data.id,
                from_email: `${currentCall._borrower_of_freshcaller_call.name} (${callParticipant?.caller_number})`,
                body: '',
                created_at: currentCall?.created_at,
                body_text: '',
                recording_id: currentCall.call_data.recording?.id,
                is_call: true,
                transcript: currentCall.transcript,
              }}
            />
          </div>
        )}
      </div>

      {/* Footer */}
      {/*  <div className="sticky bottom-0">
        <div className="flex items-center justify-between bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 px-4 sm:px-6 md:px-5 h-16">
          <button
            type="button"
            className="shrink-0 text-slate-400 dark:text-slate-500 hover:text-slate-500 dark:hover:text-slate-400 mr-3"
          >
            <span className="sr-only">Add</span>
            <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.98 5.38 18.62.02 12 0zm6 13h-5v5h-2v-5H6v-2h5V6h2v5h5v2z" />
            </svg>
          </button>

          <form className="grow flex">
            <div className="grow mr-3">
              <label htmlFor="message-input" className="sr-only">
                Type a message
              </label>
              <input
                id="message-input"
                className="form-input w-full bg-slate-100 dark:bg-slate-800 border-transparent dark:border-transparent focus:bg-white dark:focus:bg-slate-800 placeholder-slate-500"
                type="text"
                placeholder="Aa"
              />
            </div>
            <button
              type="submit"
              className="btn bg-indigo-500 hover:bg-indigo-600 text-white whitespace-nowrap"
            >
              Send -&gt;
            </button>
          </form>
        </div>
      </div> */}
    </div>
  );
}
